import e from"../palette/palette.js";const o={styleOverrides:{option:{"& .Mui-checked":{color:e.blue60.main}},listbox:{'& .MuiAutocomplete-option.Mui-focused, & .MuiAutocomplete-option[aria-selected="true"]':{backgroundColor:e.blue10.main}}}};export{o as MuiAutocomplete};
//# sourceMappingURL=MuiAutocomplete.js.map
